<div class="search-input-container">
    <div class="search-input-create-btn-wrapper">
        <div class="search-input-wrap">
            <input class="form-control form-control-custom" type="text" [placeholder]="searchPlaceholder"
                [(ngModel)]="searchText" (keyup)="searchEmployees(searchText,$event)" spellcheck="false">
            <img src="../../../../../assets/img/icons/search_icon.svg" class="search-icon" role="button" tabIndex="0" />
        </div>

        <div class="dropdown">
            <button class="btn btn-orange dropdown-toggle" type="button" data-bs-toggle="dropdown"
                aria-expanded="false">
                {{globalConstants.CREATE_REQUEST_SEARCH}}
            </button>
            <ul class="dropdown-menu">
                <li *ngIf="!nonEmployeeFlag">
                    <a class="dropdown-item" href="javascript:void(0)" (click)="openNewRequest()">
                        <img src="../../../../../assets/img/icons/add.svg" class="img-fluid" />
                        <span>{{globalConstants.NON_EMPLOYEE_REQUEST_SEARCH}}</span>
                    </a>
                </li>
                <li>
                    <a class="dropdown-item" href="javascript:void(0)" (click)="showNewRequestAccessModal()">
                        <img src="../../../../../assets/img/icons/add.svg" class="img-fluid" />
                        <span>{{globalConstants.NEW_SYSTEM_ACCESS_SEARCH}}</span>
                    </a>
                </li>
                <li>
                    <a class="dropdown-item" href="javascript:void(0)" (click)="showRevokeRequestAccessModal()">
                        <img src="../../../../../assets/img/icons/calender_close.svg" class="img-fluid" />
                        <span>{{globalConstants.REVOKE_SYSTEM_ACCESS_SEARCH}}</span>
                    </a>
                </li>
                <li>
                    <a class="dropdown-item" href="javascript:void(0)" (click)="showUpdateDetailModal()">
                        <img src="../../../../../assets/img/icons/edit_icon_black.svg" class="img-fluid" />
                        <span>{{globalConstants.UPDATE_DETAILS_SYSTEM_ACCESS_SEARCH}}</span>
                    </a>
                </li>
            </ul>
        </div>
    </div>

</div>